export default __webpack_public_path__ + "static/media/nagck.b6df5a49.jpg";